import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Sidebar from "./Aside/Sidebar";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../../../assets/css/main.css";
import "./layout.css";

const Layout = ({ pageTitle, children }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isMobile);
  const [isCollapsed, setIsCollapsed] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setWindowWidth(width);
      setIsMobile(width <= 768);
      setIsSidebarOpen(width > 768); // Close sidebar on mobile
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageTitle}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      <div className="app-wrapper">
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          windowWidth={windowWidth}
          isMobile={isMobile}
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed} // ✅ NEW
        />

        <div
          className={`main-content ${
            !isMobile && isCollapsed ? "collapsed" : ""
          }`}
        >
          <Container>{children}</Container>
        </div>
      </div>
    </>
  );
};

export default Layout;
